import { render, staticRenderFns } from "./exhibition-product-mes.vue?vue&type=template&id=0570e034&scoped=true&"
import script from "./exhibition-product-mes.vue?vue&type=script&lang=js&"
export * from "./exhibition-product-mes.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-product-mes.vue?vue&type=style&index=0&id=0570e034&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0570e034",
  null
  
)

export default component.exports